var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.75 10.88H.63a.37.37 0 0 1-.25-.38v-.38a7.12 7.12 0 0 1 6-7.03V1.5a.38.38 0 0 1 .6-.3l4.5 3.38a.37.37 0 0 1 0 .6l-4.5 3.37a.38.38 0 0 1-.6-.3v-1.4a7 7 0 0 0-4.53 2.78l-.8 1.1a.38.38 0 0 1-.3.14Zm6.38-8.63v1.17a.38.38 0 0 1-.34.38 6.38 6.38 0 0 0-5.62 5.47l.06-.08A7.76 7.76 0 0 1 6.7 6.04a.38.38 0 0 1 .38.22l.04.16V7.5l3.5-2.63-3.5-2.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharesmall);
export default __webpack_public_path__ + "static/media/share.small.8e317984be717d42afed9f60dfbf7778.svg";
export { ForwardRef as ReactComponent };